import React, { Component } from 'react';
import logo from './logo.svg';

import './Table';
import Table from "./Table";

class App extends Component {
  render() {
    return (
      <div>
          <Table />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js